import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/Home.vue'
import NotFound from '../views/404.vue';
import CrmPage from '../views/CrmPage.vue';
import ClientDashboard from '../views/ClientDashboard.vue'
import Storyboard from '../views/Storyboard.vue'
import StoryboardClient from '../views/StoryboardClient.vue'
import Settings from '../views/Settings.vue'
import LandingPage from '../views/LandingPage.vue'
import SignUp from '../views/SignUp.vue'
import ForgetPassword from '../views/ForgetPassword.vue'
import Success from '../views/Success.vue'
import Cancel from '../views/Cancel.vue'
import Meetings from '../views/MeetingsPage.vue'
import Tasks from '../views/Tasks.vue'
import Quotes from '../views/Quotes.vue'
import Pricing from  '../views/Pricing.vue'
import Inventory from  '../views/Inventory.vue'
import InventoryDetails from  '../views/InventoryDetails.vue'
import InventoryFulfilement from  '../views/InventoryFulfilement.vue'
import HumanResource from  '../views/HumanResource.vue'
import LeaveManagement from  '../views/LeaveManagement.vue'
// import ClaimManagement from  '../views/ClaimManagement.vue'
// import HRPayrollClaims from  '../views/HRPayrollClaims.vue'
// import Attendance from  '../views/Attendance.vue'
import JobManagement from  '../views/JobManagement.vue'
import JobStartEnd from  '../views/JobStartEnd.vue'




const routes = [
  { path: '/login',component: Home },
  { path: '/crm', component: CrmPage },
  { path: '/clientDashBoard/:id', component: ClientDashboard, name: 'ClientDashboard' },
  { path: '/storyboard/:id', component: Storyboard },
  { path: '/StoryboardClient/:id', component: StoryboardClient },
  { path: '/', component: LandingPage },
  { path: '/Success', component: Success },
  { path: '/Cancel', component: Cancel },
  { path: '/settings', component: Settings },
  { path: '/SignUp', component: SignUp },
  { path: '/Meetings', component: Meetings },
  { path: '/Tasks', component: Tasks },
  { path: '/Quotes', component: Quotes },
  { path: '/Pricing', component: Pricing },
  { path: '/Inventory', component: Inventory },
  { path: '/HumanResource', component: HumanResource },
  { path: '/LeaveManagement', component: LeaveManagement },
  // { path: '/ClaimManagement', component: ClaimManagement },
  // { path: '/HRPayrollClaims', component: HRPayrollClaims },
  // { path: '/Attendance', component: Attendance },
  { path: '/JobManagement', component: JobManagement },
  

  { path: '/InventoryDetails/:id', component: InventoryDetails },
  { path: '/InventoryFulfilement/:id', component: InventoryFulfilement },
  { path: '/JobStartEnd/:id', component: JobStartEnd },

  { path: '/ForgetPassword', component: ForgetPassword },
  { path: '/:pathMatch(.*)*', component: NotFound },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
